module.exports = __webpack_public_path__ + "static/media/star-fhl.2a3b28b4.png";